<template lang="pug">
    v-dialog( v-bind="dialogProps" v-model="open" )
        v-toolbar( color="blue darken-2" dark flat )
            v-toolbar-title Agregar carga familiar
            v-spacer
            v-btn( icon large @click="open = false" )
                v-icon close
        v-container( grid-list-lg )
            v-layout( row wrap )
                v-flex( xs12 )
                    v-form( ref="form" )
                        v-text-field( v-bind="textProps" v-model="rut" @keyup.enter="submit" )
                v-flex( xs text-xs-right )
                    v-btn( color="orange darken-2" dark :disabled="rut == ''" large @click="submit" ) agregar
</template>

<script>
    //
    import RUTUtils from '@/mixins/reusable_mixins/RUTUtils'
    //
    export default {
        computed: {

            /**
             * 
             */
            dialogProps () {
                return {
                    contentClass: 'white',
                    width: 1000,
                }
            },

            /**
             * 
             */
            textProps () {
                return {
                    class: 'px-2',
                    hideDetails: true,
                    outline: true,
                    placeholder: 'RUT',
                    singleLine: true,
                    rules: [ this.mixValidateRUT ],
                }
            },
        },
        data () {
            return {
                open    : false,
                rut: '',
            }
        },
        methods: {

            /**
             * 
             */
            submit () {
                
                //
                if ( this.$refs.form.validate() ) {

                    //
                    this.open = false

                    //
                    this.$emit( 'submit', { rut: this.rut } )
                }                
            },
        },
        mixins: [ RUTUtils ],
    }
</script>

<style>
    .outline-flex {
        border: 2px solid #727272;
        border-radius: 3px;
    }
</style>

